
export default function ($rootScope, $scope, $http, $cookies, $timeout, $window, $uibModalInstance, CONFIG, UtilitiesFactory, ContentFulFactory, Upload, imageUrl, ngToast) {
    'ngInject';

    let T = $scope.$root.T;
    let isbrightness = false;

    $scope.isProgress = false;
    $scope.imageUrl = imageUrl;
    $scope.newAsset = null;

    $scope.slider = {
        id:'slider',
        value: 0,
        options: {
            floor: 0,
            ceil: 10,
            step: 1,
            minLimit: 0,
            maxLimit: 10,
            onEnd: function(id) {
                let perc = ($scope.slider.value * 10) + 100;
                $rootScope.apiCropper.data.brightness = perc;
                $rootScope.apiCropper.elements.image.setAttribute('style', `filter:brightness(${ perc }%)`);
                $rootScope.apiCropper.elements.container.style.width =  $rootScope.apiCropper.width * 100 + '%';
                $rootScope.apiCropper.elements.container.style.height =  $rootScope.apiCropper.height * 100 + '%';
                let newWidth = 1;
                let newHeight = 1;
                if ($rootScope.apiCropper.angle % 180 !== 0) {
                    let ratio = $rootScope.apiCropper.height / $rootScope.apiCropper.width * $rootScope.apiCropper.imageRatio;
                    newWidth = ratio;
                    newHeight = 1 / ratio;
                }
                $rootScope.apiCropper.elements.image.style.width = newWidth * 100 + '%';
                $rootScope.apiCropper.elements.image.style.height = newHeight * 100 + '%';
                $rootScope.apiCropper.elements.image.style.left = (1 - newWidth) / 2 * 100 + '%';
                $rootScope.apiCropper.elements.image.style.top = (1 - newHeight) / 2 * 100 + '%';

                $rootScope.apiCropper.elements.image.style.webkitTransform = 'rotate(' + $rootScope.apiCropper.angle + 'deg)';
                $rootScope.apiCropper.elements.image.style.mozTransform = 'rotate(' + $rootScope.apiCropper.angle + 'deg)';
                $rootScope.apiCropper.elements.image.style.msTransform = 'rotate(' + $rootScope.apiCropper.angle + 'deg)';
                $rootScope.apiCropper.elements.image.style.oTransform = 'rotate(' + $rootScope.apiCropper.angle + 'deg)';
            }
        }
    };

    let uploadImage = (image) => {
        Upload.upload({
            url: `${CONFIG.customUploadUrl}upload`,
            data: {file: image }
        }).then( (data) => {
            console.log(data);

            /**
             * Create Asset
             */
            ContentFulFactory.createAssetFromFiles()
                .then((space) => {
                    space.createAsset({
                        fields: {
                            file: {
                                'en': {
                                    contentType: !!image.type ? image.type : "image/png",
                                    fileName: !!image.$ngfName ? image.$ngfName : !!image.name ? image.name : '',
                                    upload: data.data.url
                                }
                            }
                        }
                    })
                        .then((asset) => {
                            /**
                             * Processing asset
                             */
                            console.log('processing...', asset);
                            let p1 = asset.processForLocale('en', { processingCheckWait: 500, processingCheckRetries: 10 });
                            p1.then((value) => {
                                console.log('value', value);
                            }).catch((e) => {
                                $timeout( () => {
                                    $scope.requestInProgress = false;
                                    ngToast.create({
                                        className: 'toast-danger',
                                        content: `${T.HTTP_POST_ERROR_NOTIFICATION} ${image.$ngfName}`,
                                        timeout: 6000
                                    });
                                    $scope.isProgress = false;
                                    $uibModalInstance.close();
                                });
                                $rootScope.raven.captureException(e);
                                $rootScope.raven.showReportDialog();
                            }).then((error) => {
                                console.log(error);
                            }, (e) => {
                                $rootScope.raven.captureException(e);
                                $rootScope.raven.showReportDialog();
                            });

                            return asset.processForLocale('en', { processingCheckWait: 500, processingCheckRetries: 10 });
                        })
                        .then((asset) => {
                            /**
                             * Publishing asset
                             */
                            console.log('publishing...', asset);
                            return asset.publish();
                        })
                        .then((asset) => {
                            console.log(asset, isbrightness);
                            $scope.isProgress = false;
                            if (isbrightness) {
                                $timeout( () => {
                                    console.log(asset.fields.file.en.url);
                                    $scope.imageUrl = `https://${ asset.fields.file.en.url }`;
                                    isbrightness = false;
                                    $scope.newAsset = asset;
                                });
                            } else {
                                $uibModalInstance.close({asset});
                                ngToast.create({
                                    className: 'toast-success',
                                    content: `${image.$ngfName} ${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                                    timeout: 6000
                                });
                            }
                        })
                });
        }, (error) => {
            $scope.error = error;
        });
    };

    $scope.myButtonLabelsObject = {
        rotateLeft: T.ROTATE_LEFT,
        rotateRight: T.ROTATE_RIGHT,
        zoomIn: T.ZOOM_IN,
        zoomOut: T.ZOOM_OUT,
        fit: T.FIT,
        crop: T.CROP,
        brightness: 'brightness'
    };

    $scope.getCropperApi = (api) => {
        console.log(api);
    };

    $scope.updateResultImage = (img) => {
        console.log(img);
        img.name = "img";
        uploadImage(img);
    };

    $scope.save = () => {
        let asset = $scope.newAsset;
        $uibModalInstance.close({ asset });
    };


    document.addEventListener('cropStart', () => {
        console.log('CropStart');
        $scope.isProgress = true;
    });
}



// WEBPACK FOOTER //
// ./src/app/views/app.modal/manageImageModalCtrl.js